import React from 'react';
import { motion } from 'framer-motion';
import { Moon, Star, Flower, Coffee, BookOpen } from 'lucide-react';
export function ImpactShowcase() {
  return <section className="py-24 relative overflow-hidden bg-violet-950/10 pt-[0px] pb-[0px]" data-id="element-144">
      <div className="w-full mx-auto" data-id="element-145">
        <div className="relative flex flex-col items-center" data-id="element-146">
          {/* Main Product Mockup Container */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative z-10 w-full" data-id="element-147">
            <div className="relative overflow-hidden shadow-2xl shadow-violet-500/10" data-id="element-148">
              <img src="https://cdn.magicpatterns.com/uploads/8JMB1BSQTYYMKCyQTJVjgj/web_2.webp" alt="Kit de Liberación Emocional Showcase" className="w-full h-auto block" data-id="element-149" />
              {/* Glossy Overlay */}
              <div className="absolute inset-0 bg-gradient-to-tr from-white/5 to-transparent pointer-events-none" data-id="element-150" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}